import URLConfig from "@Config/urls/url.config";
import { LinkItemProps } from "@Layouts/sidebar/AppSidebar";

const URL = URLConfig.ADMIN.ARCHIVING.ARCHIVED_TABLES_MENU;

const ArchivedTablesMenuLink: Array<LinkItemProps> = [
  {
    name: "Consultation Transactions Valides",
    link: URL.VALID_TRANSACTION_INQUIRY,
    level: 3,
  },
  {
    name: "Consultation des autorisations",
    link: URL.CONSULTATION_OF_AUTHORIZATIONS,
    level: 3,
  },
  {
    name: "ATM Transaction Inquiry",
    link: URL.ATM_TRANSACTION_INQUIRY,
    level: 3,
  },
];

export default ArchivedTablesMenuLink;
